
import { DialogPositioningBehavior,DialogType } from '@tableau/widgets';
import React = require('react');
import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';

import { Messages } from '../../codegen/Localize';
import { ModalInstance, ReactModalService } from '../../commonInfra/dialogs/ReactModalService';
import { ServerSettingsUnauthenticated } from '../../settings/services/ServerSettingsUnauthenticated';
import { BulkImportUserDialog } from '../components/BulkImportUserDialog';

const Method ={
    ImportUsersFromCsv: 'importUsersFromCsv',
    ImportServerUsersFromCsv: 'importServerUsersFromCsv'
  };

function showBulkImportSiteUsersDialog(identityPool?: IIdentityPool): Promise<any> {
    return showBulkImportUsersDialog(Method.ImportUsersFromCsv, ServerSettingsUnauthenticated.isSiteSamlEnabled(), identityPool);
}

function showBulkImportServerUsersDialog(identityPool?: IIdentityPool): Promise<any> {
    return showBulkImportUsersDialog(Method.ImportServerUsersFromCsv, false, identityPool);
}
function showBulkImportUsersDialog(method: string, showAuthSettingSelector: boolean, identityPool?: IIdentityPool): Promise<any> {
    let modalInstance: ModalInstance;
    const dialogProps = {
        dismiss: () => modalInstance && modalInstance.dismiss(),
        close: (result: any) => modalInstance && modalInstance.close(result),
        method: method,
        showAuthSettingSelector: showAuthSettingSelector,
        identityPool: identityPool,
      };
    modalInstance = ReactModalService.open({
        type: DialogType.NormalWithTitleBar,
        dialogContent: React.createElement(BulkImportUserDialog, dialogProps),
        title: Messages.importUsers_ImportFromFile(),
        testId: 'bulkImportUsersDialog',
        showCloseButton: false,
        shouldNotSetDefaultWidth: true,
        positioningBehavior: DialogPositioningBehavior.Draggable
    });

    return modalInstance.result;
}

export const BulkImportUsersAction = {showBulkImportSiteUsersDialog, showBulkImportServerUsersDialog};
